import React from 'react';
var EditPencilIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '#363948' : _b;
    return (React.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M11.0585 6.02L11.9785 6.94L2.91854 16H1.99854V15.08L11.0585 6.02ZM14.6585 0C14.4085 0 14.1485 0.1 13.9585 0.29L12.1285 2.12L15.8785 5.87L17.7085 4.04C18.0985 3.65 18.0985 3.02 17.7085 2.63L15.3685 0.29C15.1685 0.09 14.9185 0 14.6585 0ZM11.0585 3.19L-0.00146484 14.25V18H3.74854L14.8085 6.94L11.0585 3.19Z", fill: fill })));
};
export default EditPencilIcon;
